
export const Questions2021 = Object.freeze({
    SPM2: "Hvordan stemte du, da Intact Denmarks borgerforslag blev behandlet i folketinget?"
})

export const Questions2019 = Object.freeze({
    SPM2: "Går du ind for, at Folketinget skal vedtage en 18-års aldersgrænse for omskæring af raske drenge, der ikke er medicinsk nødvendige?"
})

export const Questions2025Regional = Object.freeze({
    SPM1: "Hvis du bliver valgt, vil du arbejde for, at din region forebygger omskæring af raske drengebørn, der ikke er medicinsk nødvendige?",
    SPM2: "Går du ind for, at Folketinget skal vedtage en 18-års aldersgrænse for omskæring af raske drenge, der ikke er medicinsk nødvendige?",
    SPM3: "Ved du, hvilken holdning dit parti har til en 18-års aldersgrænse for omskæring af raske drengebørn?",
    Comment: "Eventuel kommentar",
});

export const Questions2025Kommunal = Object.freeze({
    SPM1: "Vil du arbejde for, at din kommune forebygger omskæring af drengebørn, hvis det ikke er nødvendigt af medicinsk årsager?",
    SPM2: "Går du ind for, at Folketinget skal vedtage en 18-års aldersgrænse for omskæring af raske drenge, der ikke er medicinsk nødvendige?",
    SPM3: "Ved du, hvilken holdning dit parti har til en 18-års aldersgrænse for omskæring af raske drengebørn?",
    Comment: "Eventuel kommentar",
});

export const Questions2026 = Object.freeze({
    SPM1: {
        TEXT: "1 Bør kirke og stat adskilles?",
        BREAD: "I Danmark er Folkekirken og staten tæt knyttet via kirkeskat, bloktilskud og særlige privilegier i modsætning til øvrige tros- og livssynssamfund."
    },
    SPM2: {
        TEXT: "2 Bør der være statsligt anerkendte og økonomisk understøttede trossamfund i Danmark?",
        BREAD: "Et trossamfund (frikirker, moskeer, osv.) kan blive anerkendt i Kirkeministeriet og modtage juridiske og økonomiske fordele. I alt giver staten 0,5-1 milliarder i sådanne skattefordele om året."
    },
    SPM3: {
        TEXT: "3 Bør kongen have religionsfrihed?",
        BREAD: "Ifølge Grundlovens § 6 skal Kongen være medlem af Folkekirken. Således er han frataget den livssyns- og trosfrihed (også kaldet religionsfrihed), som menneskerettighederne garanterer alle mennesker."
    },
    SPM4: {
        TEXT: "4 Bør registrering af navne, dødsfald osv. ligge hos kommunerne i stedet for folkekirken?",
        BREAD: "Civilregistrering (f.eks. navngivning af nyfødte, dødsfald og navneskifte) varetages i hovedparten af landet af Folkekirken, også for ikke-kristne f.eks. ateister, muslimer etc. Bør denne funktion overgå til kommunerne i stedet?\n \n I Sydjylland varetages civilregistrering af kommunerne."
    },
    SPM5: {
        TEXT: "5 Bør Koranloven afskaffes?",
        BREAD:
            "“Utilbørlig behandling” af et skrift, “der har væsentlig religiøs betydning for et anerkendt trossamfund” (eller en genstand, der ligner et sådant skrift) kan straffes med bøde eller fængsel på op til 2 år. Loven gælder også for den, der udbreder handlingen f.eks. ved videooptagelser til sociale medier."
    },
    SPM6: {
        TEXT: "6 Bør faget kristendomskundskab i folkeskolen ændres til et bredere dækkende fag omhandlende filosofi , idehistorie og livssyn - herunder religion?",
        BREAD: "Faget er skolelevernes primære indføring i etik, moral og filosofi. Nogle finder det nuværende indhold forældet, andre mener, at den kristne kulturarv berettiger det store fokus på kristendom."
    },
    SPM7: {
        TEXT: "7 Bør der være forbud mod at bære iøjnefaldende religiøse symboler eller klædedragter i skoler og institutioner?",
        BREAD: "I f.eks. Frankrig må lærere og elever i offentlige skoler og undervisningsinstitutioner ikke bære iøjnefaldende religiøse symboler eller klædedragter. Hensigten er at sikre et neutralt og ligeværdigt miljø med fokus på undervisning, mens religiøse overbevisninger betragtes som hørende til det private rum."
    },
    SPM8: {
        TEXT: "8 Bør offentlige institutioner, herunder skoler, stille lokaler til rådighed til religionsudøvelse?",
        BREAD: "Såkaldte stillerum bliver brugt som bederum af religiøse elever og studerende, hvilket nogle steder medvirker til negativ social kontrol af muslimske elever. Det er et spørgsmål om frihed til og fra religion."
    },
    SPM9: {
        TEXT: "9 Skal religiøse friskoler have statstilskud?",
        BREAD: "Fri- og privatskoler modtager et tilskud på 76% af udgiften til en folkeskoleelev. Også de skoler, som underviser i særlige religiøse normer og værdier." 
    },
    SPM10: {
        TEXT: "10 Bør der indføres forbud mod omvendelsesterapi til mindreårige LGBT+ personer?",
        BREAD: "Omvendelsesterapi er et bredt dækkende term for forskellige religiøse praksisser, der søger at påvirke et menneske til at undertrykke sin seksualitet eller kønsidentitet. Det er ulovligt i bl.a. Norge."
    },
    SPM11: {
        TEXT: "11 Bør der indføres forbud mod kontrakter, der f.eks. regulerer ægteskab og skilsmisse i henhold til religiøse principper?",
        BREAD: "Der er eksempler på borgere, der oplever sig fastholdt i ægteskaber pga. af religiøse kontrakter, der regulerer bodeling, samvær med fællesbørn, indgåelse af andre parforhold efter ægteskabets ophør etc."
    },
    SPM12: {
        TEXT: "12 Går du personligt ind for omskæring af raske drengebørn?",
        BREAD: "Omhandler dit personlige forhold til ikke-medicinske omskæringer af drengebørn."
    },
    SPM13: {
        TEXT: "13 Bør der indføres en 18 års mindstealder for omskæring af raske børn?",
        BREAD: "Omskæring af raske piger har været forbudt siden 2003 i henhold til Straffelovens § 245a, uanset om indgrebet udføres i Danmark eller i udlandet. Indførelse af en kønsneutral mindstealder beskytter alle børn ligeligt, uanset køn, kultur eller religion."
    }
});

export default Questions2025Kommunal;
